export default {
  SET_TENANTS_DATA(state, data) {
    state.tenants = data;
  },
};
